import React, { FC } from 'react';
import { connect } from 'react-redux';
import { WithTranslation, withTranslation } from 'react-i18next';

import MobileLogoutButton from '~src/shared/buttons/MobileLogoutButton';
import { StoreI } from '~src/rootReducer';
import { routes } from '~src/routingConfig';

import {
  MessageContainer,
  MessageText,
  MobileButton,
  OverlayContainer,
  RefreshIcon,
  StyledLink,
} from './mobileOverlay.sc';

interface StateProps {
  pendingCycles: boolean;
}

type Props = StateProps & WithTranslation;

const MobileOverlay: FC<Props> = React.memo(({ t, pendingCycles }) => (
  <OverlayContainer>
    <MessageContainer $grow={2} $noBorder>
      <RefreshIcon className="white" name="iconArrowCircle" width={60} />
      <MessageText data-translation="x.mobile.overlay.message">{t('x.mobile.overlay.message')}</MessageText>
    </MessageContainer>
    {pendingCycles && (
      <MessageContainer $grow={2}>
        <MessageText data-translation="x.mobile.overlay.message.cta">
          {t('x.mobile.overlay.message.cta')}
        </MessageText>
        <StyledLink to={routes.answerQuestions.questions}>
          <MobileButton>
            <span data-translation="x.button.mobile.overlay">{t('x.button.mobile.overlay')}</span>
          </MobileButton>
        </StyledLink>
      </MessageContainer>
    )}
    <MessageContainer $grow={1} $noBorder={!pendingCycles}>
      <MobileLogoutButton t={t} />
    </MessageContainer>
  </OverlayContainer>
));

function mapStateToProps(state: StoreI) {
  const cycles = state.user.cycles.byId;
  const pendingCycles = cycles ? Object.keys(cycles).length > 0 : false;
  return {
    pendingCycles,
  };
}

const MobileOverlayTranslated = withTranslation()(MobileOverlay);
const MobileOverlaySuper = connect(mapStateToProps)(MobileOverlayTranslated);
export default MobileOverlaySuper;
